var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',[_c('v-card-title',[_c('span',{staticClass:"headline"},[_vm._v(_vm._s(_vm.$t('footer[0].politica')))])]),_c('v-card-text',{staticClass:"text-modal"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.$t('footer[1].politicaPrivacitat'))}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }